import { Outlet, useLocation } from 'react-router-dom';
import BackButton from 'components/BackButton';
import { ROUTE_PATHS } from 'routes/constants';

const ReconciliationReports = () => {
  const location = useLocation();

  return (
    <section className={'right-section'}>
      {location.pathname !== ROUTE_PATHS.RECONCILIATION_REPORTS && <BackButton />}
      <Outlet />
    </section>
  );
};

export default ReconciliationReports;
